import React, { ReactElement } from 'react';
import { FormInstance, Form, Input, Button } from 'antd';
import { OverlayScrollbarsComponent } from 'overlayscrollbars-react';
import { CrossIcon, PlusIcon } from '@icons';

type InvitationStepProps = {
  form: FormInstance;
  loading: boolean;
  emails: string[];
  hasErrors: boolean;
  setEmails: (value: string[]) => void;
  setHasErrors: (value: boolean) => void;
};

function InvitationStep({
  form,
  loading,
  setEmails,
  emails,
  hasErrors,
  setHasErrors
}: InvitationStepProps): ReactElement {
  const handleSetErrors = () => {
    const fieldErrors = form.getFieldsError();
    const emailsErrors =
      fieldErrors.find((field) => field?.name.includes('emails'))?.errors ||
      null;
    setHasErrors(Boolean(emailsErrors && emailsErrors?.length > 0));
  };

  return (
    <div className="step_container" style={{ maxWidth: 600, margin: '0 auto' }}>
      <p className="step_container__title step_container__title--invitation">
        StreamWork is better together
      </p>
      <p className="step_container__description">
        Invite others to work with you
      </p>
      <div className="step_container__body">
        <Form.List name="emails" initialValue={[...emails]}>
          {(fields, { add, remove }) => (
            <>
              <OverlayScrollbarsComponent
                className="step_container__emails"
                events={{
                  updated(osInstance, e) {
                    if (!e.updateHints.overflowAmountChanged) return;
                    const { viewport } = osInstance.elements();
                    viewport.scroll({
                      top: viewport.scrollHeight,
                      left: 0,
                      behavior: 'smooth'
                    });
                  }
                }}
              >
                {fields.map((field, idx) => (
                  <Form.Item
                    {...field}
                    key={field.key}
                    validateTrigger="onBlur"
                    hasFeedback={false}
                    rules={[
                      {
                        type: 'email',
                        message: ''
                      }
                    ]}
                  >
                    <Input
                      onChange={() => setEmails(form.getFieldsValue().emails)}
                      size="large"
                      onBlur={() => handleSetErrors()}
                      onFocus={() => handleSetErrors()}
                      placeholder="Enter email to invite others"
                      suffix={
                        idx > 2 ? (
                          <CrossIcon
                            onClick={() => remove(idx)}
                            style={{ cursor: 'pointer' }}
                          />
                        ) : undefined
                      }
                    />
                  </Form.Item>
                ))}
              </OverlayScrollbarsComponent>
              <Button
                type="link"
                style={{ padding: 0, height: 32 }}
                onClick={() => add()}
                onMouseDown={(e) => e.preventDefault()}
                disabled={loading}
              >
                <PlusIcon style={{ marginRight: 4 }} /> Add more emails
              </Button>
              {hasErrors && (
                <div className="ant-form-item-explain-error">
                  Whoops! Some emails are invalid. Please check them for typos
                  or mistakes.
                </div>
              )}
            </>
          )}
        </Form.List>
      </div>
    </div>
  );
}

export default InvitationStep;
